import { Service } from '@mews-commander/data-access';
import { RouteName, TextKey } from '@mews-commander/enums';
import { isAdditionalService } from '@mews-commander/legacy-entities/src/ducks/servicesNew';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedProperty, LocalizedText } from '@mews/framework';
import { useResolveRoute } from '@mews/routing';
import { Link } from '@optimus-web/core';

interface Props {
    service: Service;
}
export const ServiceLink = ({ service }: Props) => {
    const { id, isActive, names } = service;
    const resolveRoute = useResolveRoute();
    const url = isAdditionalService(service)
        ? resolveRoute(RouteName.ProductServiceDetail, { id })
        : resolveRoute(RouteName.VisitDetail, { serviceId: id });

    if (isActive) {
        return (
            <Link data-service-link={id} href={url} inherit>
                <LocalizedProperty property={names} />
            </Link>
        );
    }

    return (
        <div>
            <LocalizedProperty property={names} />
            {UnicodeEntity.NoBreakSpace}
            {UnicodeEntity.LeftParenthesis}
            <LocalizedText textKey={TextKey.Deleted} />
            {UnicodeEntity.RightParenthesis}
        </div>
    );
};
